import { render, staticRenderFns } from "./ComoSeCalculaModal.vue?vue&type=template&id=2bb16cda"
import script from "./ComoSeCalculaModal.vue?vue&type=script&lang=js"
export * from "./ComoSeCalculaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports